import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FilesPluginService } from './files-plugin.service';
import { Location } from '@angular/common';
import { FilesAndSuggestionsPluginService } from '../filesandsuggestions/filesandsuggestions-plugin.service';
import { Observable, Subject, from } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component({
    templateUrl: 'photo-edit.component.html',
    standalone: false
})
export class PhotoEditPageComponent extends BaseModalPageComponent implements OnInit, AfterViewInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  assetId: string;
  public plugin: any;
  public processing = false;
  public angle = 0;
  public points;
  public undoTrigger = new Subject<any>();
  private service: any;
  public inputImage = null;
  @ViewChild('image', { static: true })
  image: ElementRef;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fileService: FilesPluginService,
    private suggestionService: FilesAndSuggestionsPluginService,
    private http: HttpClient,
    location: Location
  ) {
    super(location);
  }

  ngOnInit() {
    this.router.url.includes('fileandsuggestion')
      ? (this.service = this.suggestionService)
      : (this.service = this.fileService);
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      const assetId = params['assetId'];
      if (assetId == null) this.goToBack();

      this.assetId = assetId;

      this.http
        .get(`/api/assets/${assetId}/content`, {
          responseType: 'blob'
        })
        .pipe(
          take(1),
          switchMap((response) => {
            return from(
              new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                  resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(response);
              })
            );
          }),
          map((data) => {
            return {
              url: `/api/assets/${assetId}/content`,
              image: data,
              transformationModel: {
                rotate: 90
              }
            };
          })
        )
        .subscribe((data) => {
          this.inputImage = data;
        });

      this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
        this.plugin = data;
      });
    });
  }

  ngAfterViewInit() {
    /*this.service.getEditedImagesIds().subscribe((ids) => {
      ids.forEach((id) => {
        if (this.image.nativeElement.src.includes(id)) {
          this.image.nativeElement.src = `${this.image.nativeElement.src}?v=${Date.now()}`;
        }
      });
    });*/
  }

  getPoints(points) {
    this.points = points;
  }

  save() {
    this.processing = true;
    this.service
      .editFile(this.inspectionId, this.pointId, this.pluginId, this.assetId, this.points)
      .subscribe((res) => {
        if (res) {
          this.processing = false;
          this.goToBack();
        }
      });
  }

  cancel() {
    this.goToBack();
  }

  undoChanges() {
    this.undoTrigger.next(true);
    this.points = null;
  }
}
